import React, { useMemo } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';
import { Icon } from '../../components';

import css from './AudiencePage.module.css';

const { Money } = sdkTypes;

const membershipsData = [
  {
    key: 'first-timer',
    labelMsgId: 'AudiencePage.SectionMemberships.firstMembershipTitle',
    descriptionMsgId: 'AudiencePage.SectionMemberships.firstMembershipDescription',
    price: {
      amount: 2000,
      currency: config.currency,
    },
    perks: [
      {
        key: 'duration-1-month',
        labelMsgId: 'AudiencePage.SectionMemberships.firstMembershipPerk1',
      },
      {
        key: 'members-only-episodes',
        labelMsgId: 'AudiencePage.SectionMemberships.firstMembershipPerk2',
      },
      {
        key: 'ticket-discount-code',
        labelMsgId: 'AudiencePage.SectionMemberships.firstMembershipPerk3',
      },
    ],
  },
  {
    key: 'ballerinas',
    labelMsgId: 'AudiencePage.SectionMemberships.secondMembershipTitle',
    descriptionMsgId: 'AudiencePage.SectionMemberships.secondMembershipDescription',
    price: {
      amount: 2000,
      currency: config.currency,
    },
    perks: [
      {
        key: 'duration-2-months',
        labelMsgId: 'AudiencePage.SectionMemberships.secondMembershipPerk1',
      },
      {
        key: 'members-only-episodes',
        labelMsgId: 'AudiencePage.SectionMemberships.secondMembershipPerk2',
      },
      {
        key: 'backstage-tour-invitation',
        labelMsgId: 'AudiencePage.SectionMemberships.secondMembershipPerk3',
      },
    ],
  },
];

const MembershipPerk = ({ perk }) => (
  <li key={perk.key} className={css.membershipPerk}>
    <Icon name="check" size={16} className={css.membershipPerkIcon} />
    <p className={css.membershipPerkText}>
      <FormattedMessage id={perk.labelMsgId} />
    </p>
  </li>
);

const Membership = ({ membership, intl }) => {
  const membershipPrice = useMemo(
    () => new Money(membership.price.amount, membership.price.currency),
    [membership.price.amount, membership.price.currency]
  );

  return (
    <div className={css.membership}>
      <h3 className={css.membershipTitle}>
        <FormattedMessage id={membership.labelMsgId} />
      </h3>
      <h2 className={css.membershipPrice}>{formatMoney(intl, membershipPrice)}</h2>
      <p className={css.membershipText}>
        <FormattedMessage id={membership.descriptionMsgId} />
      </p>
      <ul className={css.membershipPerks}>
        {membership.perks.map(perk => (
          <MembershipPerk key={perk.key} perk={perk} />
        ))}
      </ul>
      <span className={css.membershipButtonMask}>
        <FormattedMessage id="AudiencePage.membershipButton" />
      </span>
    </div>
  );
};

const SectionMemberships = ({ intl }) => {
  const memberships = useMemo(() => membershipsData, []);

  return (
    <section className={css.sectionMemberships}>
      <div className={css.membershipsContent}>
        <h2 className={css.membershipsTitle}>
          <FormattedMessage id="AudiencePage.membershipTitle" />
        </h2>
        <p className={css.membershipsText}>
          <FormattedMessage id="AudiencePage.membershipText" values={{ textBreak: <br /> }} />
        </p>
      </div>
      <div className={css.memberships}>
        {memberships.map(membership => (
          <Membership key={membership.key} membership={membership} intl={intl} />
        ))}
      </div>
    </section>
  );
};

export default SectionMemberships;
